// @ts-nocheck
import { VERIFY_CODE_ERROR, VERIFY_CODE_LOADING, VERIFY_CODE_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const VerifyCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case VERIFY_CODE_LOADING:
            return Object.assign({}, state, { loading: true })
        case VERIFY_CODE_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case VERIFY_CODE_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

